import { useContext, Fragment } from 'react'
import './KnectMobileShowcase.css'

// Modules
import { Carousel } from 'react-responsive-carousel'
import 'react-responsive-carousel/lib/styles/carousel.min.css'

// Context
import AppContext from '../../Context/App/appContext'

// ===============================================================
const KnectMobileShowcase = () => {
	// ---------------------------------------------------------------
	// Context
	const appContext = useContext(AppContext)
	const { business } = appContext

	return (
		<Fragment>
			{business && (
				<Carousel autoPlay infiniteLoop showStatus={false} showIndicators={false} showThumbs={false} swipeable={false}>
					<div className='knect-mobile-showcase'>
						<picture>
							<source media="(min-width: 992px)" srcSet="https://cms.computicket.com/api/assets/mma/ce7f2267-bf12-4186-9201-51525d860a04/showcase-banner.png?version=1" />
							<source media="(min-width: 501px)" srcSet="https://cms.computicket.com/api/assets/mma/ce7f2267-bf12-4186-9201-51525d860a04/showcase-banner.png?version=1" />
							<img src="https://cms.computicket.com/api/assets/mma/d6be026b-a4ef-4526-87b3-80349da4df08/showcase-banner-mobile.png?version=1" alt="K'nect Mobile - Banking that buys you data" />
						</picture>
					</div>
				</Carousel>
			)}
		</Fragment>
	)
}

export default KnectMobileShowcase
